<template>
  <div class="alerts">
    <button @click="openFriendly" class="friendly h-empty-btn h-btn">
      <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 8.28C11 8.514 10.9094 8.6925 10.7282 8.8155C10.547 8.9385 10.3246 9 10.0611 9H0.938904C0.675352 9 0.45298 8.937 0.271788 8.811C0.090596 8.685 0 8.508 0 8.28C0 8.1 0.0592992 7.917 0.177898 7.731L4.73405 0.495C4.95148 0.165 5.20845 0 5.50494 0C5.80144 0 6.05181 0.165 6.25606 0.495L10.8221 7.74C10.9407 7.932 11 8.112 11 8.28ZM6.18688 3.681V2.367H4.81312V3.681C4.81312 3.765 4.81971 3.8445 4.83288 3.9195C4.84606 3.9945 4.86418 4.0785 4.88724 4.1715C4.9103 4.2645 4.92842 4.344 4.9416 4.41L5.19856 5.868H5.78167L6.04852 4.41C6.0617 4.35 6.08146 4.272 6.10782 4.176C6.13417 4.08 6.15394 3.9945 6.16712 3.9195C6.18029 3.8445 6.18688 3.765 6.18688 3.681ZM6.18688 7.164C6.18688 6.99 6.11935 6.843 5.98428 6.723C5.84921 6.603 5.68613 6.543 5.49506 6.543C5.31057 6.543 5.15079 6.603 5.01572 6.723C4.88065 6.843 4.81312 6.99 4.81312 7.164C4.81312 7.338 4.88065 7.4865 5.01572 7.6095C5.15079 7.7325 5.31057 7.794 5.49506 7.794C5.68613 7.794 5.84921 7.7325 5.98428 7.6095C6.11935 7.4865 6.18688 7.338 6.18688 7.164Z" fill="#F2994A"/>
      </svg>
      <span>{{ data.tank.FriendlyAlerts.length }}</span>
    </button>

    <button @click="openWarning" class="warning h-empty-btn h-btn">
      <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 8.28C11 8.514 10.9094 8.6925 10.7282 8.8155C10.547 8.9385 10.3246 9 10.0611 9H0.938904C0.675352 9 0.45298 8.937 0.271788 8.811C0.090596 8.685 0 8.508 0 8.28C0 8.1 0.0592992 7.917 0.177898 7.731L4.73405 0.495C4.95148 0.165 5.20845 0 5.50494 0C5.80144 0 6.05181 0.165 6.25606 0.495L10.8221 7.74C10.9407 7.932 11 8.112 11 8.28ZM6.18688 3.681V2.367H4.81312V3.681C4.81312 3.765 4.81971 3.8445 4.83288 3.9195C4.84606 3.9945 4.86418 4.0785 4.88724 4.1715C4.9103 4.2645 4.92842 4.344 4.9416 4.41L5.19856 5.868H5.78167L6.04852 4.41C6.0617 4.35 6.08146 4.272 6.10782 4.176C6.13417 4.08 6.15394 3.9945 6.16712 3.9195C6.18029 3.8445 6.18688 3.765 6.18688 3.681ZM6.18688 7.164C6.18688 6.99 6.11935 6.843 5.98428 6.723C5.84921 6.603 5.68613 6.543 5.49506 6.543C5.31057 6.543 5.15079 6.603 5.01572 6.723C4.88065 6.843 4.81312 6.99 4.81312 7.164C4.81312 7.338 4.88065 7.4865 5.01572 7.6095C5.15079 7.7325 5.31057 7.794 5.49506 7.794C5.68613 7.794 5.84921 7.7325 5.98428 7.6095C6.11935 7.4865 6.18688 7.338 6.18688 7.164Z" fill="#E8282F"/>
      </svg>
      <span>{{ data.tank.ErrorAlerts.length }}</span>
    </button>

    <transition name="modal-fade-scale">
      <WarningAlertModal 
        v-if="warning_modal_opened" 
        :alerts="data.tank.ErrorAlerts" 
        :name="data.name"
        @close="closeWarning"
      />
    </transition>

    <transition name="modal-fade-scale">
      <FriendlyAlertModal 
        v-if="friendly_modal_opened" 
        :alerts="data.tank.FriendlyAlerts"
        :name="data.name"
        @close="closeFriendly"
      />
    </transition>
  </div>
</template>

<script>
import WarningAlertModal from './WarningAlertModal';
import FriendlyAlertModal from './FriendlyAlertModal';

export default {
  components: {
    WarningAlertModal,
    FriendlyAlertModal,
  },
  data() {
    return {
      friendly_modal_opened: false,
      warning_modal_opened: false,
    }
  },
  props: {
    data: {}
  },
  methods: {
    openFriendly() {
      if(this.data.tank.FriendlyAlerts.length) {
        this.friendly_modal_opened = true;
        this.warning_modal_opened = false;
      } else {
        this.$shake(`#tank_${this.data.id} .alerts .friendly`);
      }
    },
    openWarning() {
      if(this.data.tank.ErrorAlerts.length) {
        this.warning_modal_opened = true;
        this.friendly_modal_opened = false;
      } else {
        this.$shake(`#tank_${this.data.id} .alerts .warning`);
      }
    },

    closeFriendly() {
      this.friendly_modal_opened = false;
    },
    closeWarning() {
      this.warning_modal_opened = false;
    },
  }
}
</script>

<style lang="scss" scoped>

.alerts {

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  flex-grow: 1;

  button {
    padding: 2px 5px;
    background: #fff;
    border-radius: 2px;
    margin-left: 10px;

    display: flex;
    flex-direction: row;
    align-items: center;

    transition: box-shadow 0.3s ease;
    box-shadow: 0 0 5px rgba(0,0,0,0.2) inset;

    &:hover {
      box-shadow: 0 0 0 rgba(0,0,0,0.2) inset;
    }

    svg {
      margin-right: 5px;
    }

    span {
      font-size: 13px;
      font-weight: 500;
      line-height: 1;
    }

    &.friendly {
      span {
        color: #F2994A;
      }
    }

    &.warning {
      span {
        color: #E8282F;
      }
    }
  }
}

</style>